import * as stateManagement from '@/stateManagement';

export const { siteScaleSel, zoomModeSel, isPinModeSel } =
  stateManagement.stateMapperArgsSelectors.otherSels;
